<template>
    <div>

        <h2 class="title has-text-weight-bold">{{getMonthYearToDisplay}}</h2>



  

                    <nav class="level is-mobile">
                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Total Price (บาท)</p>
                        <p class="title"> {{formatStringToCurrency(getTotalPriceInv)}}</p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Total Price  With Finish (บาท)</p>
                        <p class="title">{{formatStringToCurrency(getTotalPriceInvWithReceipt)}}</p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Total Price  Without Finish (บาท)</p>
                        <p class="title">{{formatStringToCurrency(getTotalPriceInvNotReceipt)}}</p>
                        </div>
                    </div>
                    
                    </nav>

                    <!-- <div class="columns">
						<div class="column is-three-quarters">
							<div class="box">
                                  <div id="chart">
                                          <apexchart width="100%" 
                                             height= "500"  
                                             type="pie" 
                                             :options="chartOptions" 
                                             :series="series"></apexchart>
                                  </div>
                            </div>
						</div>
						<div class="column">
							<div class="box has-text-centered">

                                 
                                    <p class="heading is-centered is-size-5">Total Invoice (ใบ)  :  {{getCountInv_All_Enable_Disable.count_inv_all}} </p>
                                    <p class="heading is-centered is-size-5">Invoice   Enable (ใบ)  :  {{getCountInv_All_Enable_Disable.count_inv_enable}} </p>
                                    <p class="heading is-centered is-size-5">Invoice   Disable  (ใบ)  :  {{getCountInv_All_Enable_Disable.count_inv_disable}} </p>

                            


                            </div>
						</div>
					</div> -->

                    <nav class="level is-mobile">
                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Total Invoice (ใบ)</p>
                        <p class="title"> {{getCountInv_All_Enable_Disable.count_inv_all}}</p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Invoice   Enable (ใบ)</p>
                        <p class="title">{{getCountInv_All_Enable_Disable.count_inv_enable}}</p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Invoice  Enable  With Finish (ใบ)</p>
                        <p class="title">{{getCountInv_All_Enable_Disable.count_inv_enable_with_finish}}</p>
                        </div>
                    </div>

                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Invoice Enable Without Finish (ใบ)</p>
                        <p class="title">{{getCountInv_All_Enable_Disable.count_inv_enable_without_finish}}</p>
                        </div>
                    </div>


                    <div class="level-item has-text-centered box">
                        <div>
                        <p class="heading is-size-5">Invoice   Disable  (ใบ)</p>
                        <p class="title">{{getCountInv_All_Enable_Disable.count_inv_disable}}</p>
                        </div>
                    </div>
                    
                    </nav>
 


                    <b-table
                                                                    :data="isEmpty ? [] : getMemberSummary "
                                                                    bordered
                                                                    striped
                                                                    narrowed
                                                                    hoverable
                                                                    focusable
                                                                    mobile-cards

                                                                    paginated
                                                                    :per-page="perPage"
                                                                    :current-page.sync="currentPage"
                                                                
                                                            >
                                                            <b-table-column  label="Lab Member ID" centered v-slot="props">
                                                                {{ props.row.member_id }}
                                                            </b-table-column>  

                                                            <b-table-column  label="Lab Member Name" centered v-slot="props">
                                                                {{ props.row.member_name }}
                                                            </b-table-column>  

                                                            <b-table-column  label="Invoice Count(ใบ)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_count) }}
                                                            </b-table-column>  

                                                            <b-table-column  label="Invoice Enable Count(ใบ)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_enable) }}
                                                            </b-table-column>  

                                                            <b-table-column  label="Invoice Disable Count(ใบ)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_disable) }}
                                                            </b-table-column>


                                                            <b-table-column  label="Invoice Enable With Finish Count(ใบ)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_enable_finish) }}
                                                            </b-table-column>   

                                                            <b-table-column  label="Invoice Enable Without Finish Count(ใบ)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_enable_unfinish) }}
                                                            </b-table-column>  


                                                            <b-table-column  label="Invoice Enable With Finish Sum Price(บาท)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_enable_finish_values) }}
                                                            </b-table-column>    

                                                            <b-table-column  label="Invoice Enable Without Finish Sum Price(บาท)" centered v-slot="props">
                                                                {{ formatStringToCurrency(props.row.inv_enable_unfinish_values) }}
                                                            </b-table-column>       



                                                            <template slot="empty">
                                                                <section class="section">
                                                                    <div class="content has-text-grey has-text-centered">
                                                                        <p>
                                                                            <b-icon
                                                                                    icon="table-search"
                                                                                    size="is-large">
                                                                            </b-icon>
                                                                        </p>
                                                                        <p>Nothing here.</p>
                                                                    </div>
                                                                </section>
                                                            </template>

                    </b-table>
      <!-- Total Price: {{getTotalPriceInv}}  <br/>
      Total Price  With Receipt: {{getTotalPriceInvWithReceipt}}  <br/>
      Total Price  Without Receipt:  {{getTotalPriceInvNotReceipt}}  <br/> 
       {{getCountInv_All_Enable_Disable}}<br/> 
       {{getUniqMember}}<br/> 
      {{ getMemberSummary}} -->
      <!-- StatisticsPathoInvoiceManager  <br/>
      {{getMonthYearToDisplay}}<br/>
      {{dateInvPrepareLoaded}}<br/>
      {{pathoMonthInvManagerArr}} -->
    </div>
</template>


<script>
import { mapState } from 'vuex'
import moment from 'moment-timezone' 
import {   myTimeZone }  from '@/utils.js'
import formatStringToCurrency from '../../../mixins/methods/formatStringToCurrency'

export default {
    name : "StatisticsPathoInvoiceManager",
    mixins:[formatStringToCurrency,],
    computed:{
        ...mapState({
            access_token : state => state.master_data.access_token ,
            pathoMonthInvManagerArr : state => state.patho_invoice.pathoMonthInvManagerArr ,
            dateInvManagerWant: state => state.patho_invoice.dateInvManagerWant ,
            dateInvPrepareLoaded: state => state.patho_invoice.dateInvPrepareLoaded ,
		}),


        getMonthYearToDisplay(){
            return moment(this.dateInvPrepareLoaded,myTimeZone).format('MMM   YYYY'); 
        },
        getTotalPriceInv(){
            return  this.pathoMonthInvManagerArr.map(dat=>dat.sum_price)
                                                .reduce((acc,cur)=>acc+cur,0)
        },
        getTotalPriceInvWithReceipt(){
            return  this.pathoMonthInvManagerArr.filter(dat=>dat.receipt != null)
                                                .map(dat=>dat.sum_price)
                                                .reduce((acc,cur)=>acc+cur,0)
        },
        getTotalPriceInvNotReceipt(){
            return  this.pathoMonthInvManagerArr.filter(dat=>dat.receipt == null)
                                                .map(dat=>dat.sum_price)
                                                .reduce((acc,cur)=>acc+cur,0)
        },
        getCountInv_All_Enable_Disable(){
          
                                                                 
            return {
                "count_inv_all" : this.pathoMonthInvManagerArr.length,
                "count_inv_enable"  : this.pathoMonthInvManagerArr.filter(dat=>dat.status == 0 )
                                                                  .length ,
                "count_inv_disable"  : this.pathoMonthInvManagerArr.filter(dat=>dat.status == -1 )
                                                                  .length ,
                "count_inv_enable_with_finish"  : this.pathoMonthInvManagerArr.filter(dat=>dat.status == 0 && dat.receipt != null )
                                                                              .length ,                                                 
                "count_inv_enable_without_finish"  : this.pathoMonthInvManagerArr.filter(dat=>dat.status == 0  && dat.receipt == null)
                                                                              .length ,    
            }                                     
        },
        getUniqMember(){
            const uniqueID = [...new Set(this.pathoMonthInvManagerArr.map(item => item.patho_member_id))]
            let unique = []
            for(var i=0;i<=uniqueID.length-1;i++){
                unique.push({
                    "member_id" : uniqueID[i],
                    "mamber_name" : this.pathoMonthInvManagerArr.find(dat=>dat.patho_member_id == uniqueID[i])
                                                                .patho_member_name
                })
            }
            return unique
        },
        getMemberSummary(){
            let tbl = []
            for(var i=0;i<=this.getUniqMember.length-1;i++){
               const MEMBER_ID =  this.getUniqMember[i].member_id
               const MEMBER_NAME =  this.getUniqMember[i].mamber_name
               const MEMBER_ID_ARR = this.pathoMonthInvManagerArr.filter(dat=>dat.patho_member_id == MEMBER_ID ) 
               const MEMBER_ID_ENABLE = MEMBER_ID_ARR.filter(dat=>dat.status == 0) 
               const MEMBER_ID_DISABLE = MEMBER_ID_ARR.filter(dat=>dat.status == -1)   
               const MEMBER_ID_RECEIPT = MEMBER_ID_ARR.filter(dat=>dat.receipt != null)   
               const MEMBER_ID_NOT_RECEIPT = MEMBER_ID_ARR.filter(dat=>dat.receipt == null && dat.status == 0)  
              

               tbl.push({
                "member_id": MEMBER_ID,
                "member_name" :MEMBER_NAME,
                "inv_count" : MEMBER_ID_ARR.length,
                "inv_enable" : MEMBER_ID_ENABLE.length,
                "inv_disable" : MEMBER_ID_DISABLE.length,
                "inv_enable_finish" : MEMBER_ID_RECEIPT.length,
                "inv_enable_unfinish" : MEMBER_ID_NOT_RECEIPT.length,
                "inv_enable_finish_values" : MEMBER_ID_RECEIPT.map(dat=>dat.sum_price)
                                                              .reduce((acc,cur)=>acc+cur,0) ,
                "inv_enable_unfinish_values" : MEMBER_ID_NOT_RECEIPT.map(dat=>dat.sum_price)
                                                              .reduce((acc,cur)=>acc+cur,0)                                               
               })    
            }

            return tbl

            // return null
        }



    },   
    data(){
        return{
            isEmpty : false,
            perPage : 20 ,
            currentPage : 1,



            // series:  this.getMemberSummary.map(dat=>dat.inv_enable_finish_values) ,// [44, 55, 13, 43, 22],
            // chartOptions: {
            //     chart: {
            //     width: 380,
            //     type: 'pie',
            //     },
            //     labels:   this.getMemberSummary.map(dat=>dat.member_name) , // ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
            //     responsive: [{
            //     breakpoint: 480,
            //     options: {
            //         chart: {
            //         width: 200
            //         },
            //         legend: {
            //         position: 'bottom'
            //         }
            //     }
            //     }]
            // },


          
        }
    } 
}
</script>